import React, { FC } from "react";
import { IconButton } from "@evergis/ui";

import { useWidgetContext } from "../../Dashboard/hooks/useWidgetContext";
import { WidgetType } from "../../FeatureCard/types";

export const GeometryFilterSwitcher: FC = () => {
  const { geometryFilter, toggleGeometryFilter } = useWidgetContext(WidgetType.Dashboard);

  return <IconButton kind="filter_switcher" primary={geometryFilter} onClick={toggleGeometryFilter} />;
};
